import React from "react";

export default class WhyChooseOne extends React.Component {
  componentDidMount() {
    const $ = window.$;

    if ($(".video-popup").length) {
      $(".video-popup").magnificPopup({
        type: "iframe",
        mainClass: "mfp-fade",
        removalDelay: 160,
        preloader: true,
        fixedContentPos: false,
      });
    }
  }
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    return (
      <>
        <section className="why-choose-one-sec">
          <div className="container">
            <div className="row">
              {/* Start Why Choose One Content */}
              <div className="col-xl-6">
                <div className="why-choose-one__content">
                  <div className="sec-title">
                    <div className="sec-title__tagline">
                      <h6> Why Choose Us </h6> <span className="right"></span>
                    </div>
                    <h2 className="sec-title__title">Why We Are The Best</h2>
                    <p className="sec-title__text">
                      When you choose Stonehenge Masonry and Construction,
                      you’re selecting a team with decades of experience in the
                      masonry industry. As a family - owned business, we treat
                      every project with the care and attention it deserves.
                    </p>
                  </div>

                  <div className="why-choose-one__content-top">
                    <div className="relative img-box w-[150px] h-[170px] rounded-md overflow-hidden">
                      <img
                        src={
                          publicUrl +
                          "assets/images/services/Walls/building-wall.JPG"
                        }
                        className="h-full w-full object-cover"
                        alt=""
                      />
                      <div className="absolute inset-0 bg-[#1A2E40]/50 flex items-center justify-center text-white text-sm"></div>
                    </div>
                    <div className="text-box">
                      <p>
                        Our commitment to customer satisfaction means we work
                        closely with you throughout the process, providing clear
                        communication and timely completion. Whether It’s a
                        small repair or a large-scale build, we bring the same
                        level of dedication and precision to every job. Trust us
                        to turn your vision into a solid, beautiful reality
                      </p>
                    </div>
                  </div>

                  <div className="why-choose-one__content-bottom">
                    <div className="row">
                      <div className="col-xl-6 col-lg-6 col-md-6">
                        <div className="why-choose-one__content-bottom-single">
                          <h2>We are fully insured</h2>
                          <p>
                            Your peace of mind is our priority. We are fully
                            insured, providing you with complete protection and
                            confidence throughout your project.
                          </p>
                        </div>
                      </div>

                      <div className="col-xl-6 col-lg-6 col-md-6">
                        <div className="why-choose-one__content-bottom-single">
                          <h2>Free quotes</h2>
                          <p>
                            Get a clear and accurate estimate for your project.
                            We offer free, no-obligation quotes, so you can make
                            informed decisions.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* End Why Choose One Content */}

              {/* Start Why Choose One Img */}
              <div className="col-xl-6">
                <div className="why-choose-one__img">
                  <div className="row">
                    {/* Start Why Choose One Img Single */}
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <div className="why-choose-one__img-single">
                        <div className="img-box">
                          <img
                            src={
                              publicUrl +
                              "assets/images/services/fireplaces/fireplace.webp"
                            }
                            className="h-[279px]"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    {/* End Why Choose One Img Single */}

                    {/* Start Why Choose One Img Single */}
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <div className="why-choose-one__img-single">
                        <div className="img-box">
                          <img
                            src={
                              publicUrl +
                              "assets/images/services/Patios/49D59361-CB38-4C27-A404-3BA34558BC14.JPG"
                            }
                            className="h-[279px]"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    {/* End Why Choose One Img Single */}

                    {/* Start Why Choose One Img Single */}
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <div className="why-choose-one__img-single">
                        <div className="img-box style2">
                          <img
                            src={
                              publicUrl +
                              "assets/images/services/outdoor Kitchen/R6M27970.JPG"
                            }
                            className="h-[279px]"
                            alt=""
                          />
                          <div className="video-box">
                            <a
                              href="https://www.instagram.com/p/DGt3KXeuObN/"
                              target="_blank"
                              rel="noreferrer noopener"
                            >
                              <div className="why-choose-one__video-icon">
                                <span className="fa fa-play"></span>
                                <i className="ripple"></i>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* End Why Choose One Img Single */}

                    {/* Start Why Choose One Img Single */}
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <div className="why-choose-one__img-single">
                        <div className="img-box">
                          <img
                            src={
                              publicUrl +
                              "assets/images/services/Steps/steps-lightning.webp"
                            }
                            className="h-[279px]"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    {/* End Why Choose One Img Single */}
                  </div>
                </div>
              </div>
              {/* End Why Choose One Img */}
            </div>
          </div>
        </section>
      </>
    );
  }
}
